import { createSelector, createSlice } from '@reduxjs/toolkit';
import { APP_CODE } from '../../permissions/constants';

const initialState = {
  user: {},
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.user = action.payload;
    },
    fetchUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.user = initialState.user;
    },
  },
});

export const { fetchUserRequest, fetchUserSuccess, fetchUserFailure } = userSlice.actions;

const selectUserState = (state) => state.user;

export const selectCurrentUser = createSelector([selectUserState], (userState) => userState.user || {});

export const selectUserLoading = createSelector([selectUserState], (userState) => userState.loading);

export const selectSubscriptionPermissions = createSelector(
  [selectCurrentUser],
  (user) => user.permissions?.[APP_CODE] ?? [],
);

export default userSlice.reducer;
